declare const gtag: any


const EVENT_CLAIM_REGISTERED = 'claim-registered'
const EVENT_COVID19_WARNING_SHOWN = 'covid19-warning-shown'
const INELIGIBLE_FLIGHT_ENTERED = 'ineligible-flight'


export function trackEvent (action: string) {
    if (typeof window === 'undefined' || !(window as any).gtag) return

    gtag('event', action)
}


export function trackClaimRegistered () {
    trackEvent(EVENT_CLAIM_REGISTERED)
}

export function trackCovid19WarningTriggered () {
    trackEvent(EVENT_COVID19_WARNING_SHOWN)
}

export function trackIneligibleFlightEntered () {
    trackEvent(INELIGIBLE_FLIGHT_ENTERED)
}
